import {Mixin} from "mixwith";

export const MutationObserverMixin = Mixin(superClass => class extends superClass {

	static get properties() {
		return {
			/**
			 * The observed namespace.
			 */
			ns: String,

			hasChanged: {
				attribute: false
			}
		};
	}

	constructor() {
		super();
		this._hasChangesFn = b => this.hasChanged = b;

		this.mutationAPI = MutationAPI.GlobalInstance;
	}

	connectedCallback() {
		super.connectedCallback();
		if(this.ns)
			this.mutationAPI.hasChanges(this.ns, this._hasChangesFn);
	}

	disconnectedCallback() {
		if(this.ns)
			this.mutationAPI.hasChanges(this.ns, this._hasChangesFn, true);
		super.disconnectedCallback();
	}

	hasInitialValue(ns = undefined) {
		if(!ns && !this.ns) return;
		return this.mutationAPI.hasInitialValue(ns || this.ns);
	}

	setInitialValue(value, ns = undefined) {
		if(!ns && !this.ns) return;
		this.mutationAPI.setInitialValue(ns || this.ns, value);
	}

	getInitialValue(ns = undefined) {
		if(!ns && !this.ns) return;
		this.mutationAPI.getInitialValue(ns || this.ns);
	}

	hasChanges(ns = undefined) {
		return this.mutationAPI.hasChanges(ns || this.ns);
	}

	getChanges(ns = undefined) {
		return this.mutationAPI.getChanges(ns || this.ns);
	}

	saveChanges(ns = undefined, newValue = undefined) {
		if(!ns && !this.ns) return;
		this.mutationAPI.saveChanges(ns || this.ns, newValue);
	}

	resetChanges(ns = undefined) {
		if(!ns && !this.ns) return;
		this.mutationAPI.resetChanges(ns || this.ns);
	}

});

export default MutationObserverMixin;